
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import { invitationList, getFriendExport, getAntManageInfo, patchAntManageInfo } from '@/api/antManage/antManage'
import { dateToSeconds, getCurrentDate, pickerOptions } from '@/utils/dateTime'
import { delObjEmptyKey } from '@/utils'

const initDate = getCurrentDate()
@Component({
  name: 'basicInformation',
  components: {}
})
export default class extends Vue {
  @Prop() merchant!: any
  @Prop({ required: true }) private merchantId!: any
  get language () {
    return AppModule.language
  }

  private queryForm: any = {
    username: '',
    distance: null,
    start_time: initDate[0],
    end_time: initDate[1]
  }

  private form: any = {
    close_self_rebate: false,
    close_friend_rebate: false
  }

  // 创建时间监听
  @Watch('date', { deep: true, immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }
  private date: any[] = getCurrentDate()
  private pickerOptions = pickerOptions
  private merchantList: any = []
  private loading: boolean = false
  private total = 0
  private async onloadBankAccountList () {
    try {
      this.loading = true
      const params: any = {
        id: this.merchantId,
        body: {
          ...this.queryForm,
          page_size: this.pagesize,
          page: this.currentPage
        }
      }
      await invitationList(params).then((res: any) => {
        this.merchantList = res.results
        this.total = res.count
      })
    } catch (e) {
      this.loading = false
    }
  }

  private select () {
    this.onloadBankAccountList()
  }

  private reset () {
    this.queryForm = {
      username: '',
      distance: null,
      start_time: null,
      end_time: null
    }
    this.date = getCurrentDate()
    this.onloadBankAccountList()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.onloadBankAccountList()
  }

  // 分页切换22
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.onloadBankAccountList()
  }

  // 导出
  private sendLoading: boolean = false
  private async exportData () {
    try {
      this.sendLoading = true
      const data: any = {
        id: this.merchantId,
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await getFriendExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  private async onloadAntManageInfo () {
    try {
      this.loading = true
      const data: any = {
        id: this.merchantId,
        start_time: this.queryForm.start_time,
        end_time: this.queryForm.end_time
      }
      delObjEmptyKey(data)
      await getAntManageInfo(data).then((res: any) => {
        this.loading = false
        res.extra_param.close_self_rebate ? this.form.close_self_rebate = true : this.form.close_self_rebate = false
        res.extra_param.close_friend_rebate ? this.form.close_friend_rebate = true : this.form.close_friend_rebate = false
      })
    } catch (e) {
      this.loading = false
    }
  }

  private async changeSelfRebate () {
    try {
      const data: any = {
        id: this.merchantId,
        extra_param: {
          close_self_rebate: this.form.close_self_rebate
        }
      }
      await patchAntManageInfo(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
      })
    } catch (e) {
      console.log()
    }
  }

  private async changeFriendRebate () {
    try {
      const data: any = {
        id: this.merchantId,
        extra_param: {
          close_friend_rebate: this.form.close_friend_rebate
        }
      }
      await patchAntManageInfo(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
      })
    } catch (e) {
      console.log()
    }
  }

  mounted () {
    this.onloadBankAccountList()
    this.onloadAntManageInfo()
  }
}
